/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consult_Q5_NameInputs */

const en_consult_q5_name = /** @type {(inputs: Consult_Q5_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const id_consult_q5_name = /** @type {(inputs: Consult_Q5_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nama`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Consult_Q5_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const consult_q5_name = /** @type {((inputs?: Consult_Q5_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consult_Q5_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_consult_q5_name(inputs)
	return en_consult_q5_name(inputs)
});